import { Button, Group, TextInput } from "@mantine/core";
import React, { useState } from "react";
import { Search as SearchIcon } from "lucide-react";
import Highlighter from "react-highlight-words";

const useSearch = () => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <TextInput
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch(selectedKeys, confirm, dataIndex);
          }}
          mb={8}
        />
        <Group gap="xs">
          <Button
            size="xs"
            leftSection={<SearchIcon size={14} />}
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            w={90}
          >
            Search
          </Button>
          <Button
            size="xs"
            variant="default"
            onClick={() => clearFilters && handleReset(clearFilters)}
            w={90}
          >
            Reset
          </Button>
          <Button size="xs" variant="subtle" onClick={() => close()}>
            close
          </Button>
        </Group>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchIcon
        size={14}
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.focus(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  return getColumnSearchProps;
};

export default useSearch;
